import { ActionLog } from './action-logs';

export interface ActionLogsResponse {
  count: number;
  logs: ActionLog[];
}
